<template>
  <div>
    <base-crud
      crudName="Chamados"
      newText="Novo Chamado"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :dataForm="dataForm"
      :extra="extra"
      :toadd="toadd"
      @view="view"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import { debug } from "util";

export default {
  data: function () {
    return {
      assigneds: [],
      assignedIds: [],
      table: "ticketsTable",
      pages: [],
      url: "",
      columns: [
        "client_id",
        "code",
        "subject",
        "sent",
        "status_entity",
        "created_at",
        "actions",
      ],
      tableData: ["id", "description"],
      options: {
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        filterByColumn: true,
        filterable: [
          "client_id",
          "code",
          "subject",
          "sent",
          "status_entity",
          "created_at",
        ],
        listColumns: {
          status_entity: [
            {
              id: 1,
              text: "Aberto",
            },
            {
              id: 2,
              text: "Em triagem",
            },
            {
              id: 3,
              text: "Atendimento N1",
            },
            {
              id: 4,
              text: "Atendimento N2",
            },
            {
              id: 5,
              text: "Em QA - (Testes Internos)",
            },
            {
              id: 6,
              text: "Homologação Cliente",
            },
            {
              id: 7,
              text: "Aguardando GMUD",
            },
            {
              id: 8,
              text: "Em Acompanhamento (Produção)",
            },
            {
              id: 9,
              text: "Aguardando resposta do cliente",
            },
            {
              id: 10,
              text: "Em análise",
            },
            {
              id: 11,
              text: "Finalizado",
            },
            {
              id: 12,
              text: "Na fila",
            },
            {
              id: 13,
              text: "Reaberto",
            },
          ],
        },
        debounce: 1700,
        perPageValues: [10, 25, 50, 100],
        headings: {
          client_id: "Nome do Cliente",
          code: "Número do Chamado",
          subject: "Título",
          sent: "Enviado por",
          status_entity: "Status",
          created_at: "Aberto em",
          actions: "Ações",
        },
        sortable: ["client_id", "sent", "subject", "code"],
        templates: {
          created_at: function (h, row, index) {
            return moment(row.created_at).format("DD/MM/YYYY HH:mm:ss");
          },
          status_entity: function (h, row, index) {
            if (row.status == "1") {
              return (
                <h5>
                  <span
                    style="background-color:#ce3a49; color:#fff;"
                    class="badge badge"
                  >
                    Aberto
                  </span>
                </h5>
              );
            }

            if (row.status == "2") {
              return (
                <h5>
                  <span
                    style="background-color:#429550cc; color:#fff;"
                    class="badge badge"
                  >
                    Em triagem
                  </span>
                </h5>
              );
            }
            if (row.status == "12") {
              return (
                <h5>
                  <span
                    style="background-color:#c5c73c; color:#fff;"
                    class="badge badge"
                  >
                    Na Fila
                  </span>
                </h5>
              );
            }
            if (row.status == "3") {
              return (
                <h5>
                  <span
                    style="background-color:#c2289bb4; color:#fff;"
                    class="badge badge"
                  >
                    Atendimento N1
                  </span>
                </h5>
              );
            }
            if (row.status == "4") {
              return (
                <h5>
                  <span
                    style="background-color:#b634d6b4  ; color:#fff;"
                    class="badge badge"
                  >
                    Atendimento N2
                  </span>
                </h5>
              );
            }
            if (row.status == "5") {
              return (
                <h5>
                  <span
                    style="background-color:#429550cc  ; color:#fff;"
                    class="badge badge"
                  >
                    Em QA (testes internos)
                  </span>
                </h5>
              );
            }
            if (row.status == "6") {
              return (
                <h5>
                  <span
                    style="background-color:#35be4ccc  ; color:#fff;"
                    class="badge badge"
                  >
                    Homologação Cliente
                  </span>
                </h5>
              );
            }
            if (row.status == "7") {
              return (
                <h5>
                  <span
                    style="background-color:#0aeaf1cc  ; color:#fff;"
                    class="badge badge"
                  >
                    Aguardando GMUD
                  </span>
                </h5>
              );
            }
            if (row.status == "8") {
              return (
                <h5>
                  <span
                    style="background-color:#00ff6244  ; color:#fff;"
                    class="badge badge"
                  >
                    Em Acompanhamento (Produção)
                  </span>
                </h5>
              );
            }
            if (row.status == "9") {
              return (
                <h5>
                  <span
                    style="background-color:#e2c543cc  ; color:#fff;"
                    class="badge badge"
                  >
                    Aguardando resposta do cliente
                  </span>
                </h5>
              );
            }
            if (row.status == "10") {
              return (
                <h5>
                  <span
                    style="background-color:#f0f0f0  ; color:#000;"
                    class="badge badge"
                  >
                    Em análise
                  </span>
                </h5>
              );
            }
            if (row.status == "11") {
              return (
                <h5>
                  <span
                    style="background-color:rgba(24, 209, 17, 0.664)  ; color:#fff;"
                    class="badge badge"
                  >
                    Finalizado
                  </span>
                </h5>
              );
            }
            if (row.status == "13") {
              return (
                <h5>
                  <span
                    style="background-color:#ff00009b  ; color:#fff;"
                    class="badge badge"
                  >
                    Reaberto
                  </span>
                </h5>
              );
            }
          },
          sent: function (h, row, index) {
            return row.sent ? row.sent.name : "Nenhum Registro";
          },
          client_id: function (h, row, index) {
            return row.sent
              ? row.sent.customers.customer_name
              : "Nenhum Registro";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "client_id",
            "sent.customers",
            "status_entity",
          ];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud edit fa fa-eye",
          title: "Visualizar",
          name: "view",
        },
      ],
      endPoint: "new_tickets/",
      toadd: "ticket",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  mounted() {
    console.log(this.$store.state.user);
  },
  methods: {
    view(props) {
      this.$router.push("/ticket/" + props.row.id);
    },
    query: function (query) {
      let columns = {
        client_id: "client_id",
        code: "code",
        subject: "subject",
        sent: "sent.customers[name]",
        status_entity: "status",
        created_at: "created_at",
      };
      let filters = "orderByDesc[]=id&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.teste {
  color: rgba(24, 209, 17, 0.664);
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/Crud.vue